(function () {
  // Simple veritas add-to-cart module that supports:
  // - delegated handling for a.veritas-ajax-add
  // - explicit attachment to multiple button sets via attach(selector)
  // - idempotent binding (won't double-bind the same element)
  // - programmatic trigger via VeritasAddToCart.trigger(element)
  // - dispatches veritas:cart:added and cart:changed (with rendered sections when available)

  function fetchJSON(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('Network response not ok: ' + r.status);
      return r.json();
    });
  }

  function productJsonUrlFromHref(href) {
    try {
      var url = new URL(href, window.location.origin);
      var path = url.pathname;
      var productIndex = path.indexOf('/products/');
      if (productIndex === -1) return null;
      var productPath = path.slice(productIndex).replace(/\/+$/, '');
      return productPath + '.json';
    } catch (err) {
      return null;
    }
  }

  function addVariantToCart(variantId, quantity) {
    var payload = { id: variantId, quantity: quantity };
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(payload),
    }).then(function (r) {
      return r.json().then(function (json) {
        if (!r.ok) throw json;
        return json;
      });
    });
  }

  function updateCartCountBubble(count) {
    var bubbles = document.querySelectorAll('.cart-count-bubble');
    bubbles.forEach(function (bubble) {
      var visible = bubble.querySelector('span[aria-hidden="true"]');
      var hidden = bubble.querySelector('.visually-hidden');

      if (visible) {
        if (count > 0 && count < 100) {
          visible.textContent = count;
          visible.style.display = '';
        } else {
          visible.style.display = 'none';
        }
      }

      if (hidden) {
        hidden.textContent = count === 1 ? count + ' item in cart' : count + ' items in cart';
      }

      if (count > 0) {
        bubble.style.display = '';
      } else {
        bubble.style.display = 'none';
      }
    });
  }

  function dispatchVeritasAdded(cart, addedItem, product, variant, source) {
    var evt = new CustomEvent('veritas:cart:added', {
      detail: { cart: cart, item: addedItem, product: product, variant: variant, source: source },
    });
    window.dispatchEvent(evt);
  }

  function dispatchCartChangedWithSections(cart, addedItem, product, variant, button) {
    return fetch('/?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('Sections fetch failed: ' + r.status);
        return r.json();
      })
      .then(function (sections) {
        var parsedState = {
          id: (cart && cart.token) || Date.now(),
          sections: sections,
          cart: cart,
          addedItem: addedItem,
          product: product,
          variant: variant,
          sourceElement: button,
        };
        try {
          window.dispatchEvent(new CustomEvent('cart:changed', { detail: parsedState, bubbles: true }));
        } catch (e) {
          // silent
        }
      })
      .catch(function () {
        try {
          window.dispatchEvent(
            new CustomEvent('cart:changed', {
              detail: {
                source: 'veritas',
                cart: cart,
                item: addedItem,
                product: product,
                variant: variant,
                sourceElement: button,
              },
              bubbles: true,
            })
          );
        } catch (e) {
          // silent
        }
      });
  }

  function handleAddSuccess(addedItem, button, product, variant, quantity) {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        dispatchVeritasAdded(cart, addedItem, product, variant, button);
        dispatchCartChangedWithSections(cart, addedItem, product, variant, button);
        var count = (cart && cart.item_count) || 0;
        updateCartCountBubble(count);
      })
      .catch(function () {
        dispatchVeritasAdded(null, addedItem, product, variant, button);
        try {
          window.dispatchEvent(
            new CustomEvent('cart:changed', {
              detail: {
                source: 'veritas',
                cart: null,
                item: addedItem,
                product: product,
                variant: variant,
                sourceElement: button,
              },
              bubbles: true,
            })
          );
        } catch (e) {
          // silent
        }
      });

    if (button) {
      var originalText = button.innerHTML;
      button.innerHTML = 'Added ✓';
      button.disabled = false;
      setTimeout(function () {
        button.innerHTML = originalText;
      }, 1200);
    }
  }

  function handleError(err, button) {
    if (button) {
      var originalText = button.innerText || '';
      button.innerText = 'Error — try again';
      button.disabled = false;
      setTimeout(function () {
        button.innerText = originalText;
      }, 1600);
    }
    var evt = new CustomEvent('veritas:cart:add:error', { detail: { error: err, source: button } });
    window.dispatchEvent(evt);
  }

  function resolveTarget(contextThis, e) {
    var target =
      contextThis instanceof Element
        ? contextThis
        : e && (e.currentTarget || (e.target && e.target.closest && e.target.closest('a.veritas-ajax-add')));
    if ((!target || !target.getAttribute) && e && e.target && e.target.closest) {
      var maybe = e.target.closest('a.veritas-ajax-add');
      if (maybe && maybe.getAttribute) target = maybe;
    }
    return target;
  }

  function performAddFromElement(target, e) {
    if (!target) return;
    if (e && e.preventDefault) e.preventDefault();

    if (target.disabled) return;
    target.disabled = true;

    var forcedVariantId = target.getAttribute('data-variant-id');
    var productHref = target.getAttribute('data-product-url') || target.getAttribute('href');
    var quantity = parseInt(target.getAttribute('data-quantity') || '1', 10) || 1;

    if (forcedVariantId) {
      var parsedId = parseInt(forcedVariantId, 10);
      if (!parsedId) {
        handleError({ message: 'Invalid data-variant-id: ' + forcedVariantId }, target);
        return;
      }
      addVariantToCart(parsedId, quantity)
        .then(function (addedItem) {
          handleAddSuccess(addedItem, target, null, { id: parsedId }, quantity);
        })
        .catch(function (err) {
          handleError(err, target);
        });
      return;
    }

    var productJsonPath = productJsonUrlFromHref(productHref);
    if (!productJsonPath) {
      handleError({ message: 'Unable to resolve product from URL: ' + productHref }, target);
      return;
    }

    fetchJSON(productJsonPath)
      .then(function (productResp) {
        var product = productResp.product || productResp;
        if (!product || !product.variants || product.variants.length === 0) throw { message: 'No variants found' };

        var variant =
          product.variants.find(function (v) {
            return v.available;
          }) || product.variants[0];
        if (!variant || !variant.id) throw { message: 'Invalid variant data' };

        return addVariantToCart(variant.id, quantity).then(function (addedItem) {
          handleAddSuccess(addedItem, target, product, variant, quantity);
        });
      })
      .catch(function (err) {
        handleError(err, target);
      });
  }

  // Delegated listener (works for dynamically added buttons)
  function delegatedClickListener(e) {
    var el = e.target,
      steps = 0;
    while (el && steps < 12) {
      if (el.matches && el.matches('a.veritas-ajax-add')) {
        performAddFromElement(el, e);
        break;
      }
      el = el.parentNode;
      steps++;
    }
  }

  // Attach click handlers to elements matching selector; idempotent
  function attachToSelector(selector) {
    var elements = Array.prototype.slice.call(document.querySelectorAll(selector || 'a.veritas-ajax-add'));
    var bound = [];
    elements.forEach(function (el) {
      if (!el.dataset) return;
      if (el.dataset.veritasBound === 'true') {
        bound.push(function () {
          return function () {};
        }());
        return;
      }
      var handler = function (e) {
        performAddFromElement(el, e);
      };
      el.addEventListener('click', handler, false);
      el.dataset.veritasBound = 'true';
      // return a detach function for this element
      bound.push(function () {
        return function detach() {
          el.removeEventListener('click', handler, false);
          delete el.dataset.veritasBound;
        };
      }());
    });
    // return a function to detach all bound handlers we added
    return function detachAll() {
      bound.forEach(function (fn) {
        try {
          fn();
        } catch (e) {
          // silent
        }
      });
    };
  }

  // Programmatic trigger: accept element or selector
  function triggerAdd(elementOrSelector) {
    var el =
      elementOrSelector instanceof Element
        ? elementOrSelector
        : typeof elementOrSelector === 'string'
        ? document.querySelector(elementOrSelector)
        : null;
    if (!el) return;
    performAddFromElement(el, null);
  }

  // Public API
  window.VeritasAddToCart = {
    attach: attachToSelector,
    trigger: triggerAdd,
    // For backward compatibility with event name listeners
    onVeritasAdded: function (fn) {
      if (typeof fn !== 'function') return function () {};
      window.addEventListener('veritas:cart:added', fn);
      return function () {
        window.removeEventListener('veritas:cart:added', fn);
      };
    },
  };

  // Initialize: delegated listener + update bubble listener
  function init() {
    document.addEventListener('click', delegatedClickListener, false);

    window.addEventListener('veritas:cart:added', function (ev) {
      var cart = ev && ev.detail && ev.detail.cart;
      if (!cart) return;
      updateCartCountBubble(cart.item_count || 0);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
